import { INDENT_TYPES, MAX_INDENT } from './indentConfig';

/**
 * indent — increases margin-left on the first matching block in the selection.
 * Lists (bulletList/orderedList) are indented as a container — not individual items.
 * Paragraphs inside listItems are skipped.
 */
export const indent =
    () =>
    ({ tr, state, dispatch }) => {
        const { from, to } = state.selection;
        let modified = false;

        state.doc.nodesBetween(from, to, (node, pos, parent) => {
            if (!INDENT_TYPES.includes(node.type.name)) return true;  // not a target — descend
            if (parent?.type.name === 'listItem') return false;        // paragraph inside list — skip

            const current = node.attrs.indent ?? 0;
            if (current < MAX_INDENT) {
                tr.setNodeMarkup(pos, null, { ...node.attrs, indent: current + 1 });
                modified = true;
            }
            return false; // block found — stop descent into children
        });

        if (!modified) return false;
        if (dispatch) dispatch(tr);
        return true;
    };

/**
 * outdent — decreases margin-left on the first matching block in the selection.
 */
export const outdent =
    () =>
    ({ tr, state, dispatch }) => {
        const { from, to } = state.selection;
        let modified = false;

        state.doc.nodesBetween(from, to, (node, pos, parent) => {
            if (!INDENT_TYPES.includes(node.type.name)) return true;
            if (parent?.type.name === 'listItem') return false;

            const current = node.attrs.indent ?? 0;
            if (current > 0) {
                tr.setNodeMarkup(pos, null, { ...node.attrs, indent: current - 1 });
                modified = true;
            }
            return false;
        });

        if (!modified) return false;
        if (dispatch) dispatch(tr);
        return true;
    };
